import { useEffect, useState } from 'react';
import { logger } from '../utils/logger';
import { ShoppingBag } from 'lucide-react';
import axios from 'axios';
import { MerchCard } from '../components/MerchCard';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function MerchPage() {
  const [merch, setMerch] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState('all');

  useEffect(() => {
    const fetchMerch = async () => {
      try {
        const response = await axios.get(`${API_URL}/merch`);
        setMerch(response.data);
      } catch (error) {
        logger.error('Failed to fetch merch:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchMerch();
  }, []);

  const categories = ['all', ...new Set(merch.map(item => item.category))];
  const filteredMerch = category === 'all' 
    ? merch 
    : merch.filter(item => item.category === category);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-20">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="main-content pt-24" data-testid="merch-page">
      <div className="container py-12">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-pink-500 to-purple-500 flex items-center justify-center">
              <ShoppingBag className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold">Merch</h1>
              <p className="text-gray-400">Limited edition merchandise</p>
            </div>
          </div>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium capitalize transition-colors ${
                category === cat 
                  ? 'bg-purple-500 text-white' 
                  : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white'
              }`}
              data-testid={`category-${cat}`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Merch Grid */}
        <div className="merch-grid">
          {filteredMerch.map((item) => (
            <MerchCard key={item.id} item={item} />
          ))}
        </div>

        {filteredMerch.length === 0 && (
          <div className="empty-state">
            <ShoppingBag className="empty-state-icon" />
            <h3 className="text-xl font-semibold mb-2">No items found</h3>
            <p className="text-gray-400">Try selecting a different category</p>
          </div>
        )}
      </div>
    </div>
  );
}
